module.exports = __webpack_public_path__ + "img/paintscuffs_overlay.4ec32ac2.jpeg";